import './Nav.scss';
import logoBig from "../resources/images/logo-words.svg";
import logoSmall from "../resources/images/logo-square.svg";

import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HashLink as ScrollLink } from 'react-router-hash-link';

import { Button } from './Reusable';

function Nav() {
    const [isNavOpen, setIsNavOpen] = useState(false)
    const [isScrolled, setIsScrolled] = useState(false)
    const [isContactVisible, setIsContactVisible] = useState(false)

    // nav rides transparent over the hero, then picks up a blurred backing
    useEffect(() => {
        const onScroll = () => setIsScrolled(window.scrollY > 40)

        onScroll()
        window.addEventListener('scroll', onScroll, { passive: true })
        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    // The sticky mobile CTA gets out of the way once the form is on screen —
    // otherwise it floats over the very thing it points at. On /founder there
    // is no #contact, so it simply stays available the whole way down.
    useEffect(() => {
        const target = document.getElementById('contact')
        if (!target || !('IntersectionObserver' in window)) return

        const observer = new IntersectionObserver(
            ([entry]) => setIsContactVisible(entry.isIntersecting),
            { threshold: 0 }
        )

        observer.observe(target)
        return () => observer.disconnect()
    }, [])

    const closeNav = () => setIsNavOpen(false)

    // held back over the hero, which carries its own CTA a few hundred pixels
    // below — two asks stacked on one screen reads as pushy
    const showSticky = isScrolled && !isContactVisible

    return (
        <>
            <div className={`Nav ${isScrolled ? "scrolled" : ""}`}>
                <div className='Nav-container'>
                    <div className='Nav-logo-block'>
                        <ScrollLink to="/#home">
                            <img    src={logoBig}
                                    className='Nav-logo big'
                                    alt="Candlelyte Production Text Logo"/>

                            <img src={logoSmall}
                                className='Nav-logo small'
                                alt="Candlelyte Production Icon Logo" />
                        </ScrollLink>
                    </div>

                    <button
                        className={`Nav-icon ${isNavOpen ? "open" : ""}`}
                        aria-label={isNavOpen ? "Close menu" : "Open menu"}
                        aria-expanded={isNavOpen}
                        onClick={() => setIsNavOpen(!isNavOpen)}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>

                    <div
                        className={`Nav-scrim ${isNavOpen ? "open" : ""}`}
                        onClick={closeNav}
                        aria-hidden="true"></div>

                    <ul className={`Nav-links ${isNavOpen ? "open" : ""}`}>
                        <ScrollLink to="/#home" onClick={closeNav}>
                            <header>Candle<b>lyte</b> <br />Productions</header>
                        </ScrollLink>
                        <hr />
                        {/* No "Home" — the logo to the left is already a /#home
                            ScrollLink, and no "Process": that slot was earned when
                            Process carried the positioning statement, which is its
                            own Statement band under the hero now. What is left in
                            Process is workflow, which is reassurance you read once
                            you're interested rather than somewhere you navigate to.
                            #work leads instead — CaseStudy is the only section that
                            shows rather than argues.

                            These are in PAGE ORDER, not in order of importance. The
                            links scroll rather than route, so the bar reads as a
                            labelled scrollbar: Services sat before About for a
                            moment and clicking down the list walked you backward up
                            the page. Keep them matching the stack in Home.js.
                            Founder is last because it is the one that leaves. */}
                        <li>
                            <ScrollLink to="/#work" onClick={closeNav}>Work</ScrollLink>
                        </li>
                        <li>
                            <ScrollLink to="/#about" onClick={closeNav}>About</ScrollLink>
                        </li>
                        <li>
                            <ScrollLink to="/#services" onClick={closeNav}>Services</ScrollLink>
                        </li>
                        <li>
                            <Link to="/founder" onClick={closeNav}>Founder</Link>
                        </li>

                        {/* drawer-only: the bar CTA beside it is hidden on mobile,
                            and the sticky bar sits under the scrim while this is open */}
                        <li className='Nav-drawer-cta'>
                            <Button title="Start a project" flameon={true} source="Nav drawer" />
                        </li>
                    </ul>

                    {/* desktop only — mobile has the drawer and the sticky bar */}
                    <div className='Nav-cta'>
                        <Button title="Start a project" source="Nav bar" />
                    </div>
                </div>
            </div>

            {/* Sibling of .Nav rather than a child, so it sits below the drawer
                scrim in the stacking order instead of inside .Nav's context. */}
            <div className={`Nav-sticky ${showSticky ? "show" : ""}`}>
                <Button title="Start a project" flameon={true} source="Mobile sticky bar" />
            </div>
        </>
    );
}

export default Nav;
